import React from 'react';
import Seat from '../../../components/Seat';
import WagonDoor from '../../../components/WagonDoor';
import WagonToilet from '../../../components/WagonToilet';

function FirstFloor({
  seats,
  setChosenSeats,
  chosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <div className="seats-row left" style={{ marginLeft: '20px' }}>
          <WagonDoor />
          <WagonToilet />
          <div className="seat-column">
            <Seat
              seat={seats?.[61]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[62]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed ml-4">
            <Seat
              seat={seats?.[1]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[2]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[3]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[4]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[7]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[8]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[12]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[11]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[16]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[15]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[19]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[20]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[23]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[24]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[27]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[28]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[31]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[32]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="wagon-feature" />
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[36]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[35]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[40]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[39]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[44]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[43]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[47]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[48]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[51]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[52]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[55]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[56]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[59]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[60]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>

          <WagonToilet />
          <WagonDoor />
        </div>
        <div className="seats-row bottom left" style={{ marginLeft: '72px' }}>
          <WagonDoor />
          <div className="seat-column reversed ml-[115px]">
            <Seat
              seat={seats?.[6]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[5]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[10]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[9]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[14]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[13]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[18]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[17]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[21]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[22]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[25]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[26]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[29]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[30]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[33]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[34]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="wagon-feature" />
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[38]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[37]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[42]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[41]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[46]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[45]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[49]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[50]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[53]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[54]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[57]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[58]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="wagon-feature" />
          <WagonDoor />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
